module.exports = __webpack_public_path__ + "img/Withdrawal_Crypto_manual.fb306fec.png";